/**
 * Composable for CMS Activity data extraction and normalization
 */

export const normalizeResource = (resource: any): any => {
  if (!resource) return null;
  if (Array.isArray(resource)) {
    return resource.map((item) => normalizeResource(item)).filter(Boolean);
  }
  if (resource.data) {
    return normalizeResource(resource.data);
  }
  if (resource.attributes && typeof resource.attributes === 'object') {
    return {
      id: resource.id ?? resource.attributes.id ?? null,
      ...resource.attributes,
    };
  }
  return resource;
};

const unwrapCmsActivityCandidate = (candidate: any) => {
  if (!candidate || typeof candidate !== 'object') {
    return null;
  }

  if (candidate.attributes && typeof candidate.attributes === 'object') {
    return {
      id: candidate.id ?? candidate.attributes.id ?? null,
      ...candidate.attributes,
      relationships: candidate.relationships,
      stages: candidate.stages,
      translations: candidate.translations,
      media: candidate.media,
      activity: candidate.activity,
      categories: candidate.categories,
      guiders: candidate.guiders,
      suggestedActivities: candidate.suggestedActivities,
      suggested_activities: candidate.suggested_activities,
    };
  }

  return candidate;
};

export const normalizeCmsActivity = (cmsActivity: any) => {
  if (!cmsActivity || typeof cmsActivity !== 'object') {
    return null;
  }

  const unwrapped = unwrapCmsActivityCandidate(cmsActivity);
  if (!unwrapped) {
    return null;
  }

  if (unwrapped.attributes && typeof unwrapped.attributes === 'object') {
    return unwrapCmsActivityCandidate(unwrapped);
  }

  return unwrapped;
};

export const extractRelationship = (item: any, key: string): any => {
  if (!item) return null;
  if (item[key]) return item[key];
  if (item.relationships && item.relationships[key]) {
    const relationship = item.relationships[key];
    return relationship.data ?? relationship;
  }
  return null;
};

export const extractCmsActivityData = (response: any) => {
  if (!response) {
    return null;
  }

  const candidates = [
    response,
    response?.data,
    response?.data?.data,
    response?.data?.data?.data,
    response?.data?.included,
    response?.included,
    response?.data?.attributes,
    response?.attributes,
  ];

  for (const candidate of candidates) {
    if (!candidate) {
      continue;
    }

    if (Array.isArray(candidate)) {
      const itemWithId = candidate.find((entry: any) => entry && (entry.id !== undefined && entry.id !== null));
      if (itemWithId) {
        const unwrapped = unwrapCmsActivityCandidate(itemWithId);
        if (unwrapped && (unwrapped.id !== undefined || unwrapped.title !== undefined || unwrapped.translations !== undefined)) {
          return unwrapped;
        }
      }
      continue;
    }

    const unwrapped = unwrapCmsActivityCandidate(candidate);
    if (!unwrapped) {
      continue;
    }

    if (unwrapped.id !== undefined || unwrapped.title !== undefined || unwrapped.translations !== undefined) {
      return unwrapped;
    }
  }

  return null;
};
